import RFCIdentifierModal from './RFCIdentifierModal';

export default RFCIdentifierModal;
